import * as React from 'react';

import type { DiscoveryCollection } from 'bundles/browse/components/types/DiscoveryCollections';
import { mapCollectionsForCarousel } from 'bundles/collections-carousel/utils/mappingUtils';
import { CollectionsContainer } from 'bundles/collections-common';
import ProductRecommendations from 'bundles/unified-seo-content-common/components/hub-page/ProductRecommendations';
import { ARTICLES_GRID_BREAKPOINTS_CONFIG } from 'bundles/unified-seo-content-common/constants';

import _t from 'i18n!nls/articles';

type Props = {
  shouldUseDiscoveryCollections: boolean;
  loadingDiscoveryCollectionsRecommendations: boolean;
  recommendationCollections: Array<DiscoveryCollection | null>;
  productRecsByAlgoliaMetadata: {
    productRecommendationsSearchUrl?: string | null;
    productRecommendationTitle?: string | null;
    productRecsIndexName: string;
    hitsPerPage: number;
    title: string;
  };
};

const ProductRecommendationsDelegator = ({
  shouldUseDiscoveryCollections,
  loadingDiscoveryCollectionsRecommendations,
  recommendationCollections,
  productRecsByAlgoliaMetadata,
}: Props) => {
  const { productRecommendationTitle, productRecommendationsSearchUrl, hitsPerPage, productRecsIndexName, title } =
    productRecsByAlgoliaMetadata;

  if (shouldUseDiscoveryCollections) {
    return (
      <CollectionsContainer
        collections={mapCollectionsForCarousel(recommendationCollections)}
        isCollectionsLoading={loadingDiscoveryCollectionsRecommendations}
        itemsGridConfig={ARTICLES_GRID_BREAKPOINTS_CONFIG}
      />
    );
  } else if (productRecommendationsSearchUrl) {
    return (
      <ProductRecommendations
        title={productRecommendationTitle || _t('Popular {title} Courses', { title })}
        searchURL={productRecommendationsSearchUrl}
        hitsPerPage={hitsPerPage}
        searchIndexName={productRecsIndexName}
      />
    );
  } else {
    return null;
  }
};

export default ProductRecommendationsDelegator;
